import { Component } from '@angular/core';

@Component({
  selector: 'rtr-sign-up-button',
  templateUrl: './sign-up-button.component.html',
  styleUrls: ['./sign-up-button.component.less'],
})
export class SignUpButtonComponent {}
